<script>

  export default {
    props: {
      options: {
        type: null,
        default: () => [
          { value: '', text: 'All Return Types' },
          { value: 'RES', text: 'Supplier Returns' },
          { value: 'REC', text: 'Customer Returns' },
          { value: 'RECI', text: 'Customer (Invoice) Returns' },
          { value: 'RECO', text: 'Customer (Outbound) Returns' },
        ]
      },
      filterKey: {
        type: String,
        default: 'return_document_name'
      },
      isExpanded: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        returnTypeFilter: '',
        boundCollapse: false,
      }
    },
    watch: {
      returnTypeFilter (val) {
        const payload = {}
        payload[this.filterKey] = val
        this.$emit('filter', payload)
      },
    },
    created(){
      this.boundCollapse = Boolean(this.isExpanded)
      this.boundCollapse = !this.boundCollapse
    }
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-returnType
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter Return Type</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
        />
      </h3>
    </div>
    <FabricCollapse
      id="accordion-returnType"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      :default-shown="boundCollapse">
      <div class="block-content">
        <FabricRadio 
          v-for="(option, index) in options" 
          :key="`fab-op-${index}`" 
          v-model="returnTypeFilter"
          group-name="returnTypes"
          class="tw-mt-2 tw-mb-2"
          :value="option.value">
          {{ option.text }}
        </FabricRadio>
      </div>
    </FabricCollapse>
  </div>
</template>
